module.exports = __webpack_public_path__ + "img/loading-white.83727e5f.svg";